import styled, { css } from 'styled-components';
import { palette, key } from 'styled-theme';

import { media } from '../../../helper/styleHelper';

const fontSettings = {
  small: {
    size: key('sizes.font.small', '10px'),
    spacing: '0px',
  },
  normal: {
    size: key('sizes.font.normal', '16px'),
    spacing: '0px',
  },
  header1: {
    size: key('sizes.font.header1', '26px'),
    spacing: '0px',
  },
  header2: {
    size: key('sizes.font.header2', '24px'),
    spacing: '0px',
  },
};

const xlFontSettings = {
  small: {
    size: key('sizes.xlFont.small', '10px'),
    spacing: '0px',
  },
  normal: {
    size: key('sizes.xlFont.normal', '14px'),
    spacing: '0px',
  },
  header1: {
    size: key('sizes.xlFont.header1', '22px'),
    spacing: '0px',
  },
  header2: {
    size: key('sizes.xlFont.header2', '20px'),
    spacing: '0px',
  },
};

const xlrFontSettings = {
  small: {
    size: key('sizes.xlrFont.small', '10px'),
    spacing: '0px',
  },
  normal: {
    size: key('sizes.xlrFont.normal', '20px'),
    spacing: '0px',
  },
  header1: {
    size: key('sizes.xlrFont.header1', '24px'),
    spacing: '0px',
  },
  header2: {
    size: key('sizes.xlrFont.header2', '22px'),
    spacing: '0px',
  },
};

const xxlFontSettings = {
  small: {
    size: key('sizes.xxlFont.small', '10px'),
    spacing: '0px',
  },
  normal: {
    size: key('sizes.xxlFont.normal', '20px'),
    spacing: '0px',
  },
  header1: {
    size: key('sizes.xxlFont.header1', '26px'),
    spacing: '0px',
  },
  header2: {
    size: key('sizes.xxlFont.header2', '24px'),
    spacing: '0px',
  },
};

const vxxlFontSettings = {
  small: {
    size: key('sizes.vxxlFont.small', '10px'),
    spacing: '0px',
  },
  normal: {
    size: key('sizes.vxxlFont.normal', '20px'),
    spacing: '0px',
  },
  header1: {
    size: key('sizes.vxxlFont.header1', '29px'),
    spacing: '0px',
  },
  header2: {
    size: key('sizes.vxxlFont.header2', '24px'),
    spacing: '0px',
  },
};

export const colors = {
  normal: palette('text', 0),
  black: palette('text', 1),
};

const weightSettings = {
  italic: 'JetBrains Mono Italic',
  normal: 'JetBrains Mono Regular',
  bold: 'JetBrains Mono Bold',
};

export const StyledLabel = styled.label`
  ${(props) => css`
    display: ${props.display};
    font-size: ${fontSettings[props.size].size};
    font-style: ${props.varient};
    font-family: ${weightSettings[props?.weight]};
    letter-spacing: ${fontSettings[props.size].spacing};
    color: ${colors[props.color]};
    cursor: ${props.onClick ? 'pointer' : props.cursor};
    text-align: ${props.align};
    text-transform: ${props.transform};
    ${props?.lineHeight
      ? css`
          line-height: ${props?.lineHeight};
        `
      : css``};
  `}

  ${(props) => media.xl`
    font-size: ${xlFontSettings[props.size].size};
    letter-spacing: ${xlFontSettings[props.size].spacing};
    ${
      props?.lineHeight
        ? css`
            line-height: ${props?.lineHeight};
          `
        : css``
    };
  `}
  
  ${(props) => media.xlr`
    font-size: ${xlrFontSettings[props.size].size};
    letter-spacing: ${xlrFontSettings[props.size].spacing};
    ${
      props?.lineHeight
        ? css`
            line-height: ${props?.lineHeight};
          `
        : css``
    };
  `}

  ${(props) => media.xxl`
    font-size: ${xxlFontSettings[props.size].size};
    letter-spacing: ${xxlFontSettings[props.size].spacing};
    ${
      props?.lineHeight
        ? css`
            line-height: ${props?.lineHeight};
          `
        : css``
    };
  `}

  ${(props) => media.vxxl`
    font-size: ${vxxlFontSettings[props.size].size};
    letter-spacing: ${vxxlFontSettings[props.size].spacing};
    ${
      props?.lineHeight
        ? css`
            line-height: ${props?.lineHeight};
          `
        : css``
    };
  `}

  ${(props) =>
    props?.isElips
      ? css`
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        `
      : css``}

  ${(props) =>
    props?.disabled
      ? css`
          opacity: 1;
        `
      : css`
          opacity: 1;
        `}

 
  ${({ maxWidth }) =>
    maxWidth &&
    css`
      max-width: ${maxWidth};
    `}

  svg {
    width: 10px !important;
    ${media.sm`
      width: 12px !important;
    `}
  }
`;
